<!--联系我们-->
<template>
  <div class="cu-wrap">
    <img src="../../static/contact/contact.png" alt="img" class="img" />
    <div class="cu-content">
      <div class="cu-title">[ 意见留言 ]</div>
      <div class="cu-tips">
        请留下您的意见和建议，以便我们为您提供更优质的服务
      </div>
      <el-form ref="form" :rules="rules" :model="form" class="cu-form">
        <el-form-item prop="name" class="cu-form-item">
          <el-input
            placeholder="请输入姓名"
            v-model="form.name"
            class="input-with-select"
            :maxLength="20"
          >
            <template v-slot:prepend>姓名：</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="email" class="cu-form-item">
          <el-input
            placeholder="请输入邮箱"
            v-model="form.email"
            class="input-with-select"
            :maxLength="100"
          >
            <template v-slot:prepend>邮箱：</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="phone" class="cu-form-item">
          <el-input
            placeholder="请输入联系电话"
            v-model="form.phone"
            class="input-with-select"
            :maxlength="11"
          >
            <template v-slot:prepend>电话：</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="address" class="cu-form-item">
          <el-input
            placeholder="请输入地址"
            v-model="form.address"
            class="input-with-select"
            :maxLength="200"
          >
            <template v-slot:prepend>地址：</template>
          </el-input>
        </el-form-item>
        <el-form-item prop="remark" class="cu-form-item" style="width: 930px">
          <el-input
            type="textarea"
            :rows="6"
            placeholder="您想对我们说的话"
            v-model="form.remark"
            :maxLength="500"
          ></el-input>
        </el-form-item>
        <el-button class="submit-btn" @click="handleSubmit">
          提交您的信息
        </el-button>
      </el-form>
    </div>
    <div class="cu-footer">
      <div class="item-address">
        <img
          src="../assets/contactUs/beijing.png"
          alt=""
          style="width: 546px"
        />
        <div class="item-address-val">北京市朝阳区望京SOHO塔二B座606室</div>
      </div>
      <div class="item-address">
        <img
          src="../assets/contactUs/hangzhou.png"
          alt=""
          style="width: 546px"
        />
        <div class="item-address-val">
          浙江省杭州市萧山区盈丰街道帆影路150号奥景名邸2幢602室-2
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        remark: [{ required: true, message: "请输入意见", trigger: "blur" }],
      },
      form: {},
    };
  },
  mounted() {
    this.resetForm();
  },
  methods: {
    resetForm() {
      this.form = {
        name: "",
        email: "",
        phone: "",
        address: "",
        remark: "",
      };
    },
    handleSubmit() {
      this.$refs["form"].validate((success) => {
        if (success) {
          fetch("/prod-api/system/message", {
            method: "post",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(this.form),
          })
            .then((res) => {
              return res.json();
            })
            .then((res) => {
              this.resetForm();
              if (res.resp_code === 0) {
                this.$message.success("提交成功");
              }
            });
        }
      });
    },
  },
};
</script>
<style scoped lang="less">
.cu-wrap {
  .img {
    width: 100%;
    display: block;
  }
  .cu-content {
    width: 930px;
    margin: 0 auto;
    .cu-title {
      font-family: Microsoft YaHei, serif;
      font-weight: 400;
      font-size: 50px;
      text-align: center;
      color: #333333;
      margin-top: 100px;
    }
    .cu-tips {
      font-family: Microsoft YaHei, serif;
      font-weight: 400;
      font-size: 18px;
      text-align: center;
      color: #999999;
      margin-top: 32px;
    }
  }
}

// 表单相关
.input-with-select {
  ::v-deep .el-input-group__prepend {
    background-color: #fff;
  }
}
.cu-form {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 58px;
}
.cu-form-item {
  width: 432px;
  margin-bottom: 44px;
}
.submit-btn {
  width: 587px;
  height: 60px;
  display: block;
  margin: 0 auto 63px;
  color: #fff;
  font-size: 32px;
  font-weight: 400;
  background: linear-gradient(to right, #02e1fe, #4caefe);
}
// 底部
.cu-footer {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  .item-address {
    width: 546px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .item-address-val {
      width: 396px;
      text-align: center;
      font-weight: 400;
      font-size: 20px;
      color: #888888;
      margin-top: 36px;
      margin-bottom: 38px;
    }
  }
}
</style>
